import type { AccountSiteStaffMemberModel } from '../app/types/account-site-staff-member.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const accountSiteStaffMemberApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchAccountSiteStaffMemberForStaff: builder.query<AccountSiteStaffMemberModel[], string>({
      query: key => ({ url: `/AccountSiteStaffMember/Staff/${key}` }),
      providesTags: [CacheTag.User, CacheTag.CurrentUser, CacheTag.Account],
    }),
    postAccountSiteStaffMember: builder.mutation<
      AccountSiteStaffMemberModel,
      AccountSiteStaffMemberModel
    >({
      query: post => ({
        url: `/AccountSiteStaffMember`,
        method: 'POST',
        body: post,
      }),
      invalidatesTags: [CacheTag.User, CacheTag.CurrentUser, CacheTag.Account],
    }),
    putAccountSiteStaffMember: builder.mutation<
      AccountSiteStaffMemberModel,
      AccountSiteStaffMemberModel
    >({
      query: put => ({
        url: `/AccountSiteStaffMember`,
        method: 'PUT',
        body: put,
      }),
      invalidatesTags: [CacheTag.User, CacheTag.CurrentUser, CacheTag.Account],
    }),
    deleteAccountSiteStaffMember: builder.mutation<void, string>({
      query: key => ({
        url: `/AccountSiteStaffMember/${key}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CacheTag.User, CacheTag.CurrentUser, CacheTag.Account],
    }),
  }),
});

export const {
  useFetchAccountSiteStaffMemberForStaffQuery,
  usePostAccountSiteStaffMemberMutation,
  usePutAccountSiteStaffMemberMutation,
  useDeleteAccountSiteStaffMemberMutation,
} = accountSiteStaffMemberApi;
